import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table table-striped table-hover" }
const _hoisted_4 = { scope: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_edit_button = _resolveComponent("bs5-edit-button")!
  const _component_bs5_delete_button = _resolveComponent("bs5-delete-button")!
  const _component_bs5_group_button = _resolveComponent("bs5-group-button")!
  const _component_EditDistributorModal = _resolveComponent("EditDistributorModal")!
  const _component_AddDistributorModal = _resolveComponent("AddDistributorModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Distributors", -1)),
    _createVNode(_component_bs5_base_button, {
      variant: "success",
      class: "mb-3",
      onClick: _ctx.openAddDistributorModal
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1),
        _createTextVNode(" Add Distributor ")
      ])),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "table-dark" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { scope: "col" }, "#"),
            _createElementVNode("th", { scope: "col" }, "Name"),
            _createElementVNode("th", { scope: "col" }, "Description"),
            _createElementVNode("th", { scope: "col" }, "Actions")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributors, (distributor, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: distributor.id as string
            }, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(distributor.name), 1),
              _createElementVNode("td", null, _toDisplayString(distributor.description), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_bs5_group_button, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_bs5_edit_button, {
                      onClick: ($event: any) => (_ctx.openEditDistributorModal(distributor.id as string))
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_bs5_delete_button, {
                      onClick: ($event: any) => (_ctx.deleteDistributor(distributor.id as string))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_EditDistributorModal, {
      visible: _ctx.showEditDistributorModal,
      distributorId: _ctx.selectedDistributorId as string,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEditDistributorModal = false)),
      onDistributorUpdated: _ctx.fetchDistributors
    }, null, 8, ["visible", "distributorId", "onDistributorUpdated"]),
    _createVNode(_component_AddDistributorModal, {
      visible: _ctx.showAddDistributorModal,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddDistributorModal = false)),
      onDistributorAdded: _ctx.fetchDistributors
    }, null, 8, ["visible", "onDistributorAdded"])
  ]))
}